module.exports = __webpack_public_path__ + "static/media/modeloParticipanteCampanha.3645027f.xlsx";